module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Simple-Line-Icons.woff
// module id = 287
// module chunks = 0